import { FC } from "react"
import * as QAIcons from "../../../../libs/corporate/icons/outlined/quickAccessBar/QuickAccessBarCollection"
import BaseIconButton, { IIconButtonProps } from "../BaseIconButton"

export const FileAndFolderButton: FC<IIconButtonProps> = (props) => {
    return (
        <BaseIconButton {...props}>
            <QAIcons.FileAndFolderPlusIcon />
        </BaseIconButton>
    )
}